import {
	get,
	post,
	axiosErrorHandler,
} from 'models/shared/helpers/axiosInstance';
import { BelvoEmploymentResult } from '../interfaces/belvo.interface';

export const BELVO_ENABLED = false;

export const getBelvoEmployment = async (
	ozonerId: string,
): Promise<BelvoEmploymentResult> => {
	try {
		const res = await get<BelvoEmploymentResult>(
			`/v1/belvo/employment/ozoner/${ozonerId}`,
		);

		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};

export const syncBelvoEmployment = async (
	ozonerId: string,
): Promise<BelvoEmploymentResult> => {
	try {
		const res = await post<BelvoEmploymentResult>(
			`/v1/belvo/employment/ozoner/${ozonerId}/sync`,
		);

		return res.data;
	} catch (err: any) {
		throw axiosErrorHandler(err);
	}
};
